module.exports = __webpack_public_path__ + "static/img/Chen_Yu-Hsiu.jpg";